<template>
  <Toast />
  <ConfirmPopup></ConfirmPopup>
  <div class="provider-view">
    <div class="header-section">
      <div class="header-content">
        <div class="title-section">
          <h1 class="title">Offers</h1>
          <span class="catalog-badge">Connector Catalog</span>
        </div>
        <div style="margin-left: auto">
          <button class="btn-header btn-primary-asset" @click="createOffer()">
            <svg class="i" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Add Offer
          </button>
        </div>
      </div>
    </div>

    <div class="filter-bar">
      <div class="filter-label">Filter</div>
      <div class="filter-group">
        <button
          class="filter-btn"
          :class="{ active: sourceView === 'all' }"
          @click="switchSource('all')"
        >
          <i class="pi pi-layer-group"></i>
          All
          <span class="filter-count">{{ totalOffers }}</span>
        </button>
        <button
          class="filter-btn"
          :class="{ active: sourceView === 'store' }"
          @click="switchSource('store')"
        >
          <i class="pi pi-box"></i>
          Store
          <span class="filter-count">{{ storeOffers.length }}</span>
        </button>
        <button
          class="filter-btn"
          :class="{ active: sourceView === 'connector' }"
          @click="switchSource('connector')"
        >
          <i class="pi pi-database"></i>
          Connector
          <span class="filter-count">{{ contractDefinitions.length }}</span>
        </button>
      </div>
    </div>

    <section class="assets-section">
      <div v-if="visibleOffers.length" class="policies-grid">
        <div v-for="item in visibleOffers" :key="item.key" class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-shield" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">{{ getOfferTitle(item) }}</h3>
              <div class="policy-type">{{ getOfferTypeLabel(item) }}</div>
            </div>
          </div>

          <div class="policy-card-body">
            <div class="policy-info-item">
              <div class="asset-meta">
                <span
                  v-if="item.store && item.connector"
                  class="source-tag source-tag--ok"
                >
                  Store
                </span>
                <span
                  v-if="item.store && item.connector"
                  class="source-tag source-tag--ok"
                >
                  Connector
                </span>
                <span
                  v-if="item.store && !item.connector"
                  class="source-tag source-tag--bad"
                >
                  Store
                </span>
                <span
                  v-if="item.connector && !item.store"
                  class="source-tag source-tag--ok"
                >
                  Connector
                </span>
                <!-- <span
                  v-if="item.connector && !item.store"
                  class="source-tag source-tag--bad"
                >
                  In Store
                </span> -->
              </div>
            </div>

            <div class="policy-info-item" v-if="item.store?.contentData">
              <span class="info-label">
                <i class="pi pi-box"></i>
                Asset
              </span>
              <span class="info-value">{{
                item.store.contentData.assetsSelector.operandRight
              }}</span>
            </div>

            <div
              class="policy-info-item"
              v-if="item.connector?.assetsSelector.operandRight && !item.store"
            >
              <span class="info-label">
                <i class="pi pi-box"></i>
                Asset
              </span>
              <span class="info-value">{{
                item.connector?.assetsSelector.operandRight
              }}</span>
            </div>

            <div class="policy-info-item" v-if="item.store?.contentData">
              <span class="info-label">
                <i class="pi pi-shield"></i>
                Policy
              </span>
              <span class="info-value">{{
                item.store.contentData.contractPolicyId.substring(0, 20) + "..."
              }}</span>
            </div>

            <div class="policy-info-item" v-if="item.connector && !item.store">
              <span class="info-label">
                <i class="pi pi-shield"></i>
                Policy
              </span>
              <span class="info-value">{{
                item.connector.contractPolicyId.substring(0, 20) + "..."
              }}</span>
            </div>
          </div>

          <div class="policy-card-actions">
            <Button
              v-if="item.connector && item.store"
              @click="openContractDetails(item.connector)"
              label="View Offer Details"
              icon="pi pi-eye"
              outlined
              class="view-details-btn"
            />
            <Button
              v-if="item.store && !item.connector"
              label="Publish"
              icon="pi pi-cloud-upload"
              class="btn btn-primary"
              @click="$emit('publish-asset', item.store)"
            />
            <button
              v-if="item.connector && !item.store"
              class="btn btn-primary"
              @click="pushToStore(item.connector)"
            >
              Push to Store
            </button>
            <button
              v-if="item.store"
              class="delete-icon"
              @click="confirm2($event, item.store)"
              aria-label="Delete asset"
            >
              <svg viewBox="0 0 24 24">
                <path
                  d="M3 6h18M8 6V4h8v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div v-else class="empty-state">
        <div class="empty-icon">
          <i
            class="pi"
            :class="{
              'pi-box': sourceView === 'store',
              'pi-tag': sourceView === 'connector',
              'pi-layer-group': sourceView === 'all',
            }"
            style="font-size: 3rem; color: #a0aec0"
          ></i>
        </div>
        <h3 class="empty-title">{{ emptyTitle }}</h3>
        <p class="empty-description">{{ emptyDescription }}</p>
        <Button
          v-if="sourceView === 'connector'"
          label="Create First Offer"
          icon="pi pi-plus"
          class="btn btn-primary empty-action"
        />
      </div>
    </section>

    <Dialog
      v-model:visible="contractDialogVibile"
      :style="{ width: '50vw', maxWidth: '800px' }"
      :maximizable="true"
      :modal="true"
      :closable="true"
      header="Data Offer Details"
    >
      <div v-if="selectedContract" class="policy-details">
        <div class="details-section">
          <pre class="context-json p-3 border-round surface-900 text-white">{{
            JSON.stringify(selectedContract, null, 2)
          }}</pre>
        </div>
      </div>
      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          @click="contractDialogVibile = false"
          class="p-button-text"
        />
        <Button
          label="Export JSON"
          icon="pi pi-download"
          @click="exportContractJson"
          class="p-button-outlined"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="showPublishOffer"
      :style="{ width: '50vw', maxWidth: '800px' }"
      :maximizable="true"
      :modal="true"
      :closable="true"
      header="Publish Offers"
      class="modal-overlay"
    >
      <div>
        <div class="modal modal-glass modal--lg">
          <div class="modal__content">
            <div class="form-grid">
              <div class="form-item form-item--full">
                <div class="policy-form">
                  <div class="form-item">
                    <label>Select an Asset</label>
                    <select v-model="customOffer.assetId" class="custom-input">
                      <option
                        v-for="item in storeAssets"
                        :key="item.contentData?.['@id']"
                        :value="item.contentData?.['@id']"
                      >
                        {{ item?.name }}
                      </option>
                    </select>
                  </div>

                  <div class="form-item">
                    <label>Select a Contract Policy</label>
                    <select
                      v-model="customOffer.contractPolicyId"
                      class="custom-input"
                    >
                      <option
                        v-for="policy in storePolicies"
                        :key="policy.contentData?.['@id']"
                        :value="policy.contentData?.['@id']"
                      >
                        {{ policy?.name }}
                      </option>
                    </select>
                  </div>

                  <div class="form-item">
                    <label>Select a Access Policy</label>
                    <select
                      v-model="customOffer.accessPolicyId"
                      class="custom-input"
                    >
                      <option
                        v-for="policy in storePolicies"
                        :key="policy.contentData?.['@id']"
                        :value="policy.contentData?.['@id']"
                      >
                        {{ policy?.name }}
                      </option>
                    </select>
                  </div>

                  <div class="policy-preview">
                    <button class="btn btn-primary" @click="toggleShowPreview">
                      <i class="pi pi-users"></i> Show Preview
                    </button>
                    <div v-if="showPreview" style="margin-top: 20px">
                      <h4>Generated Offer</h4>
                      <pre class="code-preview">{{ generateCustomOffer }}</pre>
                    </div>
                  </div>

                  <div class="advanced-section">
                    <button
                      type="button"
                      class="section-toggle"
                      @click="offerAdvancedOpen = !offerAdvancedOpen"
                    >
                      <span>Advanced Settings</span>
                      <i
                        class="pi pi-chevron-down toggle-icon"
                        :class="{ open: offerAdvancedOpen }"
                      ></i>
                    </button>
                    <transition name="fade-slide">
                      <div v-if="offerAdvancedOpen" class="advanced-panel">
                        <div class="toggle-row">
                          <span>Exists in connector</span>
                          <label class="toggle">
                            <input
                              v-model="customOffer.existsInConnector"
                              type="checkbox"
                            />
                            <span class="toggle-track"></span>
                          </label>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          @click="showPublishOffer = false"
          class="p-button-text"
        />
        <Button
          label="Save Offer"
          class="p-button-outlined"
          @click="publishOffer"
        />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from "vue";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import axios from "axios";
import { getCurrentInstance } from "vue";
import { useConfirm } from "primevue/useconfirm";
import ConfirmPopup from "primevue/confirmpopup";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";

const { appContext } = getCurrentInstance();
const API_BASE_URL = appContext.config.globalProperties.$apiBase;

const props = defineProps({
  providerAssets: {
    type: Array,
    default: () => [],
  },
  policies: {
    type: Array,
    default: () => [],
  },
  contractDefinitions: {
    type: Array,
    default: () => [],
  },
  storePolicies: {
    type: Array,
    default: () => [],
  },
  storeAssets: {
    type: Array,
    default: () => [],
  },
  storeOffers: {
    type: Array,
    default: () => [],
  },
  user: {
    type: String,
    default: null,
  },
  initialSource: {
    type: String,
    default: "all",
  },
});

const emit = defineEmits(["publish-asset", "refresh-assets", "push-to-store"]);

watch(
  () => props.initialSource,
  (next) => {
    if (next && next !== sourceView.value) {
      sourceView.value = next;
    }
  }
);

const sourceView = ref(props.initialSource || "all");
const contractDialogVibile = ref(false);
const selectedContract = ref(null);
const showPublishOffer = ref(false);
const showPreview = ref(false);
const offerAdvancedOpen = ref(false);
const toast = useToast();

const confirm = useConfirm();

const customOffer = ref({
  contractPolicyId: "",
  accessPolicyId: "",
  assetId: "",
  existsInConnector: false,
});

const switchSource = (view) => {
  sourceView.value = view;
};

const totalOffers = computed(
  () => props.storeOffers.length + props.contractDefinitions.length
);

const getStoreOfferId = (offer) =>
  offer?.externalId || offer?.contentData?.["@id"] || offer?.id;
const getStoreOfferName = (offer) => offer?.name || offer?.contentData?.name;
const getConnectorOfferId = (offer) => offer?.["@id"] || offer?.id;
const getConnectorOfferName = (offer) => offer?.name;

const storeOffersById = computed(() => {
  const map = new Map();
  props.storeOffers.forEach((offer) => {
    const key = getStoreOfferId(offer);
    if (key) map.set(key, offer);
  });
  return map;
});

const storeOffersByName = computed(() => {
  const map = new Map();
  props.storeOffers.forEach((offer) => {
    const key = getStoreOfferName(offer);
    if (key) map.set(key, offer);
  });
  return map;
});

const pushToStore = async (offer) => {
  const offerStorePayload = {
    ownerId: props.user,
    externalId: offer["@id"],
    objectType: { name: "offer", level: 0 },
    name: offer.name || offer["@id"] || "Unnamed Policy",
    description: offer.description || "",
    comments: offer.comments || "",
    version: offer.version || "1.0",
    tags: offer.tags || [],
    metadata: {
      additionalProp1: {
        inConnector: true,
      },
    },
    contentType: "json",
    contentData: offer,
  };
  console.log("Pushing policy to store:", offerStorePayload);
  const response = await axios.post(
    `${API_BASE_URL}/repository/insert`,
    offerStorePayload,
    {
      params: {
        "API-KEY": "C5CC3F19",
      },
      headers: {
        Accept: "application/json",
        "API-KEY": "C5CC3F19",
      },
    }
  );

  console.log("Response from asset store: ", response.data);

  if (response.data.acknowledged) {
    // Reset form and notify parent
    emit("refresh-assets");
    toast.add({
      severity: "success",
      summary: "Added to the store",
      life: 5000,
    });
    //emit("update:modelValue", "subscriber");
  } else {
    throw new Error(response.data.error || "Failed to register asset");
  }
};

const confirm2 = (event, offer) => {
  confirm.require({
    target: event.currentTarget,
    message: "Do you want to delete this record?",
    icon: "pi pi-info-circle",
    rejectProps: {
      label: "Cancel",
      severity: "secondary",
      outlined: true,
    },
    acceptProps: {
      label: "Delete",
      severity: "danger",
    },
    accept: async () => {
      console.log("Attempting to delete policy with ID:", offer);
      try {
        const selectedOffer = visibleOffers.value.find(
          (o) => o.key == offer.externalId
        );
        if (selectedOffer.connector) {
          const response = await axios.delete(
            `${API_BASE_URL}/provider/offer/${selectedOffer.key}`
          );
          console.log("Response from provider API:", response.data);
          if (response.data.success) {
            await axios.delete(
              `${API_BASE_URL}/repository/delete/${selectedOffer.store.id}`,
              {
                params: {
                  file_id: selectedOffer.store.id, // required query param
                },
              }
            );
            emit("refresh-assets");
            toast.add({
              severity: "warn",
              summary: "Deleted",
              detail: "Offer deleted successfully from provider",
              life: 5000,
            });
          } else {
            alert(
              "Failed to delete policy from provider: " + response.data.error
            );
          }
        } else {
          const response = await axios.delete(
            `${API_BASE_URL}/repository/delete/${selectedOffer.store.id}`,
            {
              params: {
                file_id: selectedOffer.store.id, // required query param
              },
            }
          );
          if (response.data.acknowledged) {
            toast.add({
              severity: "warn",
              summary: "Deleted",
              detail: "Offer deleted successfully from provider",
              life: 5000,
            });
            emit("refresh-assets");
          }
        }
      } catch (error) {
        const errormsg = error.response?.data?.detail?.[0]?.message;
        console.error("Failed to delete policy:", errormsg);
        alert(`Failed to delete policy: ${errormsg}`);
      }
    },
  });
};

const connectorOffersById = computed(() => {
  const map = new Map();
  props.contractDefinitions.forEach((offer) => {
    const key = getConnectorOfferId(offer);
    if (key) map.set(key, offer);
  });
  return map;
});

const connectorOffersByName = computed(() => {
  const map = new Map();
  props.contractDefinitions.forEach((offer) => {
    const key = getConnectorOfferName(offer);
    if (key) map.set(key, offer);
  });
  return map;
});

const findConnectorForStore = (offer) => {
  const id = getStoreOfferId(offer);
  if (id && connectorOffersById.value.has(id)) {
    return connectorOffersById.value.get(id);
  }
  const name = getStoreOfferName(offer);
  if (name && connectorOffersByName.value.has(name)) {
    return connectorOffersByName.value.get(name);
  }
  return null;
};

const findStoreForConnector = (offer) => {
  const id = getConnectorOfferId(offer);
  if (id && storeOffersById.value.has(id)) return storeOffersById.value.get(id);
  const name = getConnectorOfferName(offer);
  if (name && storeOffersByName.value.has(name)) {
    return storeOffersByName.value.get(name);
  }
  return null;
};

const mergedOffers = computed(() => {
  const map = new Map();
  const matchedConnector = new Set();
  props.storeOffers.forEach((offer) => {
    const key = getStoreOfferId(offer) || getStoreOfferName(offer);
    if (!key) return;
    const connector = findConnectorForStore(offer);
    if (connector) {
      const cKey =
        getConnectorOfferId(connector) || getConnectorOfferName(connector);
      if (cKey) matchedConnector.add(cKey);
    }
    map.set(key, { key, store: offer, connector });
  });
  props.contractDefinitions.forEach((offer) => {
    const key = getConnectorOfferId(offer) || getConnectorOfferName(offer);
    if (!key) return;
    if (matchedConnector.has(key)) return;
    const storeMatch = findStoreForConnector(offer);
    if (storeMatch) return;
    map.set(key, { key, store: null, connector: offer });
  });
  return Array.from(map.values());
});

const storeViewOffers = computed(() =>
  props.storeOffers.map((offer) => {
    const key = getStoreOfferId(offer) || getStoreOfferName(offer);
    return {
      key: key || offer.id,
      store: offer,
      connector: findConnectorForStore(offer),
    };
  })
);

const connectorViewOffers = computed(() =>
  props.contractDefinitions.map((offer) => {
    const key = getConnectorOfferId(offer) || getConnectorOfferName(offer);
    return {
      key: key || offer["@id"],
      store: findStoreForConnector(offer),
      connector: offer,
    };
  })
);

const visibleOffers = computed(() => {
  if (sourceView.value === "all") return mergedOffers.value;
  if (sourceView.value === "store") return storeViewOffers.value;
  return connectorViewOffers.value;
});

const getOfferTitle = (item) =>
  item.store?.name ||
  item.connector?.["@id"] ||
  item.connector?.name ||
  "Offer";

const getOfferTypeLabel = (item) => {
  if (item.store && !item.connector) return "Store Offer";
  if (item.connector) return item.connector["@type"] || "ContractDefinition";
  return "Store Offer";
};

const emptyTitle = computed(() => {
  if (sourceView.value === "store") return "No offers in store";
  if (sourceView.value === "connector") return "No offers available";
  return "No offers available";
});

const emptyDescription = computed(() => {
  if (sourceView.value === "store") {
    return "Store offers will appear here once the store database is connected.";
  }
  if (sourceView.value === "connector") {
    return "Create offers to make your assets available to consumers.";
  }
  return "Once offers are added, they will appear here from both sources.";
});

const publishStoreOffer = (offer) => {
  alert(
    `Store offer "${offer.name}" will publish to the connector when store integration is ready.`
  );
};

const generateCustomOffer = computed(() => {
  const policy = {
    "@context": ["https://w3id.org/edc/connector/management/v0.0.1"],
    "@type": "ContractDefinition",
    "@id": `${customOffer.value.assetId}-${customOffer.value.contractPolicyId}`,
    accessPolicyId: customOffer.value.accessPolicyId,
    contractPolicyId: customOffer.value.contractPolicyId,
    assetsSelector: {
      "@type": "Criterion",
      operandLeft: "https://w3id.org/edc/v0.0.1/ns/id",
      operator: "=",
      operandRight: customOffer.value.assetId,
    },
  };
  return JSON.stringify(policy, null, 2);
});

const openContractDetails = (contract) => {
  selectedContract.value = contract;
  contractDialogVibile.value = true;
};

const exportContractJson = () => {
  if (!selectedContract.value) return;
  const dataStr = JSON.stringify(selectedContract.value, null, 2);
  const dataUri =
    "data:application/json;charset=utf-8," + encodeURIComponent(dataStr);
  const exportFileDefaultName = `${
    selectedContract.value["@id"] || "policy"
  }.json`;
  const linkElement = document.createElement("a");
  linkElement.setAttribute("href", dataUri);
  linkElement.setAttribute("download", exportFileDefaultName);
  linkElement.click();
};

const createOffer = () => {
  showPublishOffer.value = true;
  offerAdvancedOpen.value = false;
  customOffer.value.existsInConnector = false;
};

const toggleShowPreview = () => {
  showPreview.value = !showPreview.value;
};

async function publishOffer() {
  try {
    let offerPayload = null;

    if (!customOffer.value.assetId) {
      throw new Error("Asset selection is required");
    }

    offerPayload = JSON.parse(generateCustomOffer.value);

    const policyStorePayload = {
      ownerId: props.user || "unknown",
      externalId: offerPayload["@id"] || `offer-${Date.now()}`,
      objectType: { name: "offer", level: 0 },
      name: offerPayload["@id"] || "Unnamed Offer",
      description: offerPayload.description || "",
      comments: offerPayload.comments || "",
      version: offerPayload.version || "1.0",
      tags: offerPayload.tags || [],
      metadata: {
        additionalProp1: {
          inConnector: Boolean(customOffer.value.existsInConnector),
        },
      },
      contentType: "json",
      contentData: offerPayload,
    };

    console.log("Offer being published is: ", policyStorePayload);

    console.log("Store offers: ", props.storeOffers);

    const exist = props.storeOffers.some((offer) => {
      return offer.externalId == policyStorePayload.externalId;
    });

    if (exist) {
      throw new Error("Offer already exist");
    }

    // const response = await axios.post(`${API_BASE_URL}/offer/publish`, {
    //   custom_offer: offerPayload,
    // });

    const response = await axios.post(
      `${API_BASE_URL}/repository/insert`,
      policyStorePayload
    );

    console.log("Response from repository API:", response.data);

    if (response.data.acknowledged) {
      toast.add({
        severity: "success",
        summary: "Added",
        detail: "Offer published successfully!",
        life: 5000,
      });
      showPublishOffer.value = false;
      emit("refresh-assets");
    } else {
      throw new Error(response.data.error || "Failed to publish offer");
    }
  } catch (error) {
    console.error("Error publishing offer:", error);
    toast.add({
      severity: "error",
      summary: "Error Message",
      detail:
        error.response?.data?.detail ||
        error.message ||
        "Failed to publish offer",
      life: 5000,
    });
  }
}
</script>

<style scoped src="../assets/provider-view.css"></style>
